import React from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { ApolloProvider } from "@apollo/client";
import { HelmetProvider } from "react-helmet-async";
import createCache from "@emotion/cache";
import { CacheProvider } from "@emotion/react";

import createClient from "core/includes/apollo";
import App from "./App";

const emotionCache = createCache({key: 'css'});
const client = createClient();
const container = document.getElementById('root') as HTMLElement;

// It should define RouterProvider to use useBlocker (RouteLeavingGuard > unstable_useBlocker).
const router = createBrowserRouter([
    { path: "*", element: <App /> },
]);

const app = (
    <React.StrictMode>
        <HelmetProvider>
            <CacheProvider value={emotionCache}>
                <ApolloProvider client={client}>
                    <RouterProvider router={router} />
                </ApolloProvider>
            </CacheProvider>
        </HelmetProvider>
    </React.StrictMode>
);

if (container.hasChildNodes()) {
    // @ts-ignore
    hydrateRoot(container, app);
} else {
    const root = createRoot(container);
    root.render(app);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
